import { clearAllTabFilters } from '@/hooks/useTabFilters';
import { writeActingTenant } from '@/utils/actingTenant';

export function switchActingTenant(code: string): void {
  clearAllTabFilters();
  try {
    sessionStorage.clear();
  } catch {}
  writeActingTenant(code);
}
